import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FullWidthContainer from 'components/consumer/FullWidthContainer';
import CtaButton from 'components/essentials/Cta/CtaButton';
import CtaLink from 'components/essentials/Cta/CtaLink';
import useUserData from 'data-hooks/useUserData';
import CustomerDashboardNavLinks from './components/CustomerDashboardNavLinks';
import CustomerDashboardBreadcrumb from './components/CustomerDashboardBreadcrumb';
import { navLinks } from './customerDashboardLinks';
const CustomerDashboardPageTemplateUI = t0 => {
  const $ = _c(34);
  const {
    children,
    email,
    onLogoutClick,
    parentPageItem,
    showBreadcrumb: t1,
    showSidebar: t2,
    showTitle: t3,
    title,
    titleComponent,
    variant
  } = t0;
  const showBreadcrumb = t1 === undefined ? true : t1;
  const showSidebar = t2 === undefined ? true : t2;
  const showTitle = t3 === undefined ? true : t3;
  const {
    isLoggedIn
  } = useUserData();
  let t4;
  if ($[0] !== parentPageItem) {
    t4 = parentPageItem ? [parentPageItem] : [];
    $[0] = parentPageItem;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const parentPageBreadcrumbArray = t4;
  let t5;
  if ($[2] !== title) {
    t5 = title ? [{
      label: title,
      link: "."
    }] : [];
    $[2] = title;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const currentPageBreadcrumbArray = t5;
  let t6;
  if ($[4] !== showSidebar) {
    t6 = showSidebar && <div className="bg-gray-light9 hidden w-[300px] xl:flex xl:flex-col xl:justify-between"><div className="pt-[60px] sticky top-0"><CustomerDashboardNavLinks items={navLinks} /><div className="bg-gray-light9 mt-10 pt-0 pr-6 pb-8 pl-[52px]"><div className="text-sm text-gray-light1 mb-2">Have a question or issue?</div><CtaLink to="/contact-us/" styling="solid-button" color="brand" size="sm">Contact us</CtaLink></div></div></div>;
    $[4] = showSidebar;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== currentPageBreadcrumbArray || $[7] !== parentPageBreadcrumbArray || $[8] !== showBreadcrumb) {
    t7 = showBreadcrumb && <CustomerDashboardBreadcrumb items={[...parentPageBreadcrumbArray, ...currentPageBreadcrumbArray]} />;
    $[6] = currentPageBreadcrumbArray;
    $[7] = parentPageBreadcrumbArray;
    $[8] = showBreadcrumb;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== showTitle || $[11] !== title || $[12] !== titleComponent) {
    t8 = showTitle && titleComponent ? <h1 className="text-[clamp(1.75rem,5.2vw,2.5rem)] leading-[clamp(2.25rem,6.25vw,3rem)] tracking-[.0125rem] font-bold text-gray mt-0 mx-0 mb-6 max-[1023px]:px-4 max-[1023px]:py-0">{titleComponent || title}</h1> : showTitle && title ? <h1 className="text-[clamp(1.75rem,5.2vw,2.5rem)] leading-[clamp(2.25rem,6.25vw,3rem)] tracking-[.0125rem] font-bold text-gray mt-0 mx-0 mb-6 max-[1023px]:px-4 max-[1023px]:py-0">{titleComponent || title}</h1> : null;
    $[10] = showTitle;
    $[11] = title;
    $[12] = titleComponent;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = variant === "BuildUpdatesPage";
  let t10;
  if ($[14] !== t9) {
    t10 = classNames("flex flex-col mt-0 mx-4 mb-6 lg:flex-row lg:m-0", {
      "max-[767px]:ml-0 max-[767px]:mr-0": t9
    });
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== children || $[17] !== t10) {
    t11 = <div className={t10}>{children}</div>;
    $[16] = children;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== email || $[20] !== isLoggedIn || $[21] !== onLogoutClick) {
    t12 = isLoggedIn && <span className="max-[1023px]:items-center max-[1023px]:[border-top:1px_solid_#f1f1f1] max-[1023px]:flex max-[1023px]:justify-between first:max-[1023px]:[border-top:0]"><span>Logged in as {email}</span><span className="max-[1023px]:hidden">  •  </span><CtaButton hasArrow={false} noLinkPadding={true} color="brand" size="sm" styling="link" onClick={onLogoutClick}>Log out</CtaButton></span>;
    $[19] = email;
    $[20] = isLoggedIn;
    $[21] = onLogoutClick;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="max-[1023px]:items-center max-[1023px]:[border-top:1px_solid_#f1f1f1] max-[1023px]:flex max-[1023px]:justify-between first:max-[1023px]:[border-top:0] md:hidden"><span>Have a question or issue?</span><a className="text-base font-bold text-brand !no-underline whitespace-nowrap max-[1023px]:block max-[1023px]:pt-4 max-[1023px]:pr-0 max-[1023px]:pb-4 max-[1023px]:pl-4 hover:!no-underline hover:cursor-pointer" href="/contact-us/">Contact us</a></span>;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12) {
    t14 = <div className="text-base [border-top:1px_solid_#e5e5e5] text-gray-light1 flex mt-20 pt-10 flex-col max-[1023px]:text-sm max-[1023px]:[border-top:0] max-[1023px]:mt-2 max-[1023px]:mb-2 max-[1023px]:pt-0 max-[1023px]:pl-4 max-[1023px]:pr-4">{t12}{t13}</div>;
    $[24] = t12;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t14 || $[28] !== t7 || $[29] !== t8) {
    t15 = <div className="mx-auto my-0 max-w-[1100px] px-0 py-2.5 w-full lg:px-0 lg:py-[55px] xl:px-0 xl:py-[65px] lg:pl-[30px] lg:pr-[30px] xl:m-0 xl:pl-[60px] xl:pr-[60px]">{t7}{t8}{t11}{t14}</div>;
    $[26] = t11;
    $[27] = t14;
    $[28] = t7;
    $[29] = t8;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15 || $[32] !== t6) {
    t16 = <FullWidthContainer className="flex justify-start relative w-full xl:min-h-[calc(100vh_-_3.75rem_-_36px_-_var(--visible-promotion-banner-height)_)]">{t6}{t15}</FullWidthContainer>;
    $[31] = t15;
    $[32] = t6;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
};
CustomerDashboardPageTemplateUI.propTypes = {
  children: PropTypes.node,
  email: PropTypes.string,
  onLogoutClick: PropTypes.func,
  parentPageItem: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string
  }),
  showBreadcrumb: PropTypes.bool,
  showTitle: PropTypes.bool,
  title: PropTypes.string,
  titleComponent: PropTypes.string,
  showSidebar: PropTypes.bool,
  variant: PropTypes.oneOf(['BuildUpdatesPage'])
};
export default CustomerDashboardPageTemplateUI;